import { Avatar } from 'primereact/avatar';
import HistoryTabLogic from './HistoryTab.logic';
import classes from './HistoryTab.module.scss';
import { getInitials } from 'utils/getInitials';
import { observer } from 'mobx-react';
import moment from 'moment';
import { Skeleton } from 'primereact/skeleton';
import { getBackgroundColor } from 'utils/avatarUtilities';
import { Tooltip } from 'primereact/tooltip';

const HistoryTab = ({ iterationId }: { iterationId: number }) => {
  const { iterationHistoryLoading, iterationHistory, iterationHistoryError } =
    HistoryTabLogic(iterationId);

  // const processDescriptionValue = (data: string) => {
  //   const filtered_data = data.replace(/<[^>]+>/g, "");

  //   if (filtered_data.length > 20) {
  //     return filtered_data.substring(0, 20) + "...";
  //   } else {
  //     return filtered_data;
  //   }
  // };

  // const tooltipChecker = (
  //   item: {
  //     Field: string;
  //     OldValue: string;
  //     NewValue: string;
  //     LastModifiedDate: string;
  //     LastModifiedBy: string;
  //   },
  //   key: keyof {
  //     Field: string;
  //     OldValue: string;
  //     NewValue: string;
  //     LastModifiedDate: string;
  //     LastModifiedBy: string;
  //   }
  // ) => {
  //   if (item.Field === "Description") {
  //     const str = item[key].replace(/<[^>]+>/g, "");
  //     if (str.length > 20) {
  //       console.log(str, str.length > 20);
  //       return true;
  //     }
  //   } else {
  //     return false;
  //   }
  // };

  const processDescriptionValue = (data: string) => {
    const filtered_data = data.replace(/<[^>]+>/g, '');
    if (filtered_data.length > 20) {
      return filtered_data.substring(0, 20) + '...';
    } else {
      return filtered_data;
    }
  };
  const tooltipChecker = (
    item: {
      Field: string;
      OldValue: string;
      NewValue: string;
      LastModifiedDate: string;
      LastModifiedBy: string;
    },
    key: keyof {
      Field: string;
      OldValue: string;
      NewValue: string;
      LastModifiedDate: string;
      LastModifiedBy: string;
    }
  ): boolean => {
    if (item.Field === 'Description') {
      const str = item[key].replace(/<[^>]+>/g, '');
      if (str.length > 20) {
        return true;
      }
    }
    return false;
  };

  return (
    <>
      {iterationHistoryLoading ? (
        <Skeleton height="100%" width="100%"></Skeleton>
      ) : iterationHistoryError && iterationHistory === null ? (
        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '2rem',
          }}
        >
          No History available!!
        </div>
      ) : (
        <div className={classes.historyContainer}>
          <table style={{ width: '100%' }}>
            <tbody>
              {iterationHistory?.History.map((item, idx) => {
                return (
                  <tr key={idx} className={classes.historyRow}>
                    <td>
                      <Avatar
                        title={item.LastModifiedBy}
                        id="profileAvatar"
                        shape="circle"
                        label={item.LastModifiedBy && getInitials(item?.LastModifiedBy)}
                        style={{
                          backgroundColor: getBackgroundColor(item.LastModifiedBy[0]),
                          color: '#522D6E',
                          padding: '1.1rem',
                          marginLeft: '0.5rem',
                        }}
                      />
                    </td>
                    <td>
                      <div>
                        updated the
                        <span
                          className={classes.fieldSpan}
                          style={{
                            paddingLeft: '0.3rem',
                            paddingRight: '0.3rem',
                          }}
                        >
                          {item?.Field.includes('ID')
                            ? item?.Field.substring(0, item?.Field.length - 2)
                            : item?.Field}
                        </span>{' '}
                        {item.OldValue && (
                          <>
                            from
                            {tooltipChecker(item, 'OldValue') ? (
                              <Tooltip
                                target={'#old' + idx}
                                mouseTrack
                                mouseTrackLeft={10}
                                position="top"
                                style={{ maxWidth: '30vw' }}
                              />
                            ) : null}
                            <span
                              id={item?.Field === 'Description' ? 'old' + idx : ''}
                              className={classes.fromSpan}
                              style={{
                                paddingLeft: '0.3rem',
                                paddingRight: '0.3rem',
                              }}
                              data-pr-tooltip={item?.OldValue.replace(/<[^>]+>/g, '')}
                            >
                              {item?.Field === 'Description'
                                ? processDescriptionValue(item?.OldValue)
                                : item?.OldValue}
                            </span>{' '}
                          </>
                        )}
                        to
                        {tooltipChecker(item, 'NewValue') ? (
                          <Tooltip
                            target={'#new' + idx}
                            mouseTrack
                            mouseTrackLeft={10}
                            position="top"
                            style={{ maxWidth: '30vw' }}
                          />
                        ) : null}
                        <span
                          id={item?.Field === 'Description' ? 'new' + idx : ''}
                          data-pr-tooltip={item?.NewValue.replace(/<[^>]+>/g, '')}
                          className={classes.toSpan}
                          style={{
                            paddingLeft: '0.3rem',
                            paddingRight: '0.3rem',
                          }}
                        >
                          {item?.Field === 'Description'
                            ? processDescriptionValue(item?.NewValue)
                            : item?.NewValue}
                        </span>
                      </div>
                      <div className={classes.dateSection}>
                        {moment(item?.LastModifiedDate).format('DD MMM YYYY hh:mm a')}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default observer(HistoryTab);
